import { Button, Stack } from '@mui/material'

import { AdminsTable } from './AdminsTable'
import { EstablishmentTabEnum, useEstablishmentTab } from './EstablishmentTabs'
import { Trans } from '@lingui/macro'
import CreateAdminDialog from '../../establishments/components/CreateAdminDialog'
import { useParams } from 'react-router-dom'
import { useState } from 'react'

export function AdminTabPanel() {
  const tab = useEstablishmentTab()

  if (tab !== EstablishmentTabEnum.ADMIN) return null

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="end">
        <AddAdminButton />
      </Stack>
      <AdminsTable />
    </Stack>
  )
}

function AddAdminButton() {
  const { establishmentId } = useParams<{ establishmentId: string }>()

  const [open, setOpen] = useState(false)

  if (!establishmentId) return null

  return (
    <>
      <Button data-testid="add-admin" onClick={() => setOpen(true)} variant="contained">
        <Trans>Add admin</Trans>
      </Button>
      <CreateAdminDialog establishmentId={establishmentId} open={open} onClose={() => setOpen(false)} />
    </>
  )
}
